export default __webpack_public_path__ + "static/media/accredited-provider-badge2.2890c99b.svg";